import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import 'url-search-params-polyfill';
import { PageHeader, SearchBar, SearchResults } from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';


class SearchPage extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    let page = 1;
    let query = '';
    if (location && location.search && location.search.length > 0) {
      const params = new URLSearchParams(location.search);
      const urlQuery = params.get('query');
      if (urlQuery) {
        page = parseInt(params.get('page'), 10);
        query = urlQuery;
      }
    }
    this.state = {
      query,
      results: [],
      updateQuery: (newQuery) => {
        this.setState({ query: newQuery });
      },
      updateResults: (results) => {
        this.setState({ results });
      },
      searchIndex: props.data.siteSearchIndex.index,
      page
    };
  }

  render() {
    const title = 'Search Results';
    const layoutProps = {
      activeIndex: 1,
      above: () => (
        <div>
          <PageHeader title={title} />
          <SearchBar {...this.state} />
        </div>
      ),
      pageTitle: title,
      hideHeaderSearch: true
    };
    const { location } = this.props;
    let { page } = this.state;
    if (location && location.search && location.search.length > 0) {
      const params = new URLSearchParams(location.search);
      const urlQuery = params.get('query');
      if (urlQuery) {
        // This key ensures the components update when paging.
        layoutProps.key = `layout.${urlQuery}`;
        page = parseInt(params.get('page'), 10);
      }
    }
    const resultsProps = {
      ...this.state,
      page
    };
    // metadata for the page
    const metaTitle = title;
    const metaDescription = 'Internal search for the governor\'s budget recommendation.';
    return(
      <Fragment>
        <HelmetData {...{
          metaTitle,
          metaDescription
        }}
        />
        <Layout {...layoutProps}>
          <SearchResults {...resultsProps} />
        </Layout>
      </Fragment>
    );
  }
}

SearchPage.propTypes = {
  location: PropTypes.object,
  data: PropTypes.object
};

export default SearchPage;

export const query = graphql`
  query SearchPageQuery {
    site {
      ...SiteMetadata
    }
    siteSearchIndex {
      index
    }
  }
`;
